angular.module('unica_notification_template.notification_template_services')

.factory('NotificationTemplateEditService', function ($http, getBaseApiURL) {

	var notificationTemplateEditService = {};

	notificationTemplateEditService.update = function (notificationTemplateData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-template/update/' + notificationTemplateData.id,
			data: notificationTemplateData
		}).then(function(result) {

			if ( result ) {
				return result.data.notification_template;
			}

		});
	};

	return notificationTemplateEditService;
});